import { isTouchEvent } from './isTouchEvent.js';

const getCoordinateFromEvent = evt => {
  if (isTouchEvent(evt)) {
    return {
      x: evt.touches[0]?.pageX ?? 0,
      y: evt.touches[0]?.pageY ?? 0
    };
  }
  if ("button" in evt) {
    return {
      x: evt.pageX,
      y: evt.pageY
    };
  }
  if (evt.currentTarget instanceof HTMLElement) {
    const rect = evt.currentTarget.getBoundingClientRect();
    return {
      x: rect.right + window.scrollX,
      y: rect.top + window.scrollY
    };
  } else {
    return {
      x: 0,
      y: 0
    };
  }
};

export { getCoordinateFromEvent };
//# sourceMappingURL=getCoordinateFromEvent.js.map
